module.exports = __webpack_public_path__ + "r-v3/img/repeat_one.24a1efcb.svg";